import React, { FC, memo } from 'react';

import Checkbox from '@zvuk-b2b/react-uikit/ui/Checkbox';

import { DATA_TEST_IDS } from '../../consts';
import { ReportRecipientOptionProps } from './types';

import styles from './index.module.scss';

const ReportRecipientOption: FC<ReportRecipientOptionProps> = ({ recipient, isChecked, onChange }) => (
  <li
    className={styles.option}
    data-testid={DATA_TEST_IDS.RECIPIENT_OPTION(recipient.id)}>
    <Checkbox
      elementId={DATA_TEST_IDS.RECIPIENT_OPTION_CHECKBOX(recipient.id)}
      className={styles.checkbox}
      buttonClassName={styles.checkboxButton}
      labelClassName={styles.label}
      isChecked={isChecked}
      onChange={(value) => onChange(recipient.id, value)}>
      <span
        className={styles.email}
        data-testid={DATA_TEST_IDS.RECIPIENT_OPTION_EMAIL(recipient.id)}>
        {recipient.email}
      </span>
    </Checkbox>
  </li>
);

export default memo(ReportRecipientOption);
